import { Button, Modal, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

interface LeaveSuccessAlertModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const LeaveSuccessAlertModal = ({
  opened,
  onClose,
  onConfirm,
}: LeaveSuccessAlertModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal.Root opened={opened} onClose={onClose} size="md">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{t('회원 탈퇴')}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text size="md" c="gray.7">
            {t('지금까지 이용해 주셔서 감사했습니다.')}
            <br />
            {t('더 좋은 서비스로 성장해 다시 만나뵐 수 있으면 좋겠습니다.')}
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button size="md" variant="filled" color="infgreen" onClick={onConfirm}>
            {t('확인')}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
